/* @flow */
import { observable } from 'mobx';

import { ApiModel } from 'api/ApiModel';
import type { BlockedEmailDomain } from 'models/BlockedEmailDomains';

export default class EmailDomainsStore extends ApiModel {
  @observable selectedEmailDomain: BlockedEmailDomain;
}
